import React from "react";
import EditAddPerson from "./EditAddPerson";


const EditPerson =  () =>{
    return(
        <EditAddPerson editPerson personalLoan/>
    )
};
export default EditPerson;